const MAR212_API_URL = "https://script.google.com/macros/s/AKfycbzJQb16iGRxR7fj59oP0RpAJIiAXlUtLQuY6AvMakGIsZLAjjdRqpoYXLauGwPBfv_w/exec";

document.addEventListener('DOMContentLoaded', function () {
  const questions = [
    ["Ta ville marocaine de cœur ❤️", ["Tanger","Casablanca","Nador","Oujda","Agadir","Fès","Marrakech","Rabat","Tétouan","Al Hoceima","Autre"]],
    ["Quand tu arrives au Maroc, tu fais quoi en premier ?", ["Voir la famille","Manger direct","Thé à la menthe","Plage","Chercher le Wi-Fi"]],
    ["Ton plat marocain préféré ?", ["Couscous","Tajine","Rfissa","Pastilla","Harira","Sardines grillées","Bissara"]],
    ["Le mot que tu utilises le plus ?", ["Safi","Khoya","Daba","Bzzaf","Wili Wili","Inchallah"]],
    ["Ton heure marocaine officielle ?", ["Toujours à l’heure","10 minutes de retard","30 minutes de retard","J’arrive, mais je suis encore chez moi"]],
    ["Maroc joue un match important, tu es où ?", ["Télé avec le maillot","Café avec les amis","WhatsApp toute la soirée","Je crie avant le but"]],
    ["Ton joueur marocain préféré ?", ["Hakimi","Bounou","Ziyech","Amrabat","El Kaabi","En-Nesyri","Autre légende"]],
    ["Ton acteur marocain préféré ?", ["Hassan El Fad","Rachid El Ouali","Mohamed El Jem","Saïd Naciri","Autre"]],
    ["Au souk tu es plutôt :", ["Je négocie toujours","Dernier prix ?","Je fais semblant de partir","Je paie directement"]],
    ["Le thé parfait ?", ["Très sucré","Normal","Sans sucre","Avec beaucoup de mousse"]],
    ["Quand quelqu’un dit : on part dans 5 minutes", ["5 minutes","20 minutes","1 heure","Demain"]],
    ["Ton endroit préféré au Maroc ?", ["Plage","Médina","Stade","Souk","Montagne","Maison familiale"]],
    ["Ton niveau de Darija ?", ["Courant","Je comprends tout","Je mélange","Je connais juste Safi"]],
    ["Quand tu rentres du Maroc, ta valise contient :", ["Huile d’olive","Amlou","Épices","Babouches","Gâteaux","Tout ça à la fois"]],
    ["Ton style musical marocain préféré ?", ["Chaâbi","Rai marocain","Gnawa","Issawa","Chants de stade"]],
    ["Ton meilleur souvenir du Maroc ?", ["Vacances d’été","Mariage","Match du Maroc","Soirées familiales","Route vers le bled"]],
    ["Quand tu vois un maillot du Maroc dans la rue :", ["Je souris","Je dis Dima Maghrib","Je demande où il l’a acheté","Je regarde le design"]],
    ["Quand le Maroc gagne :", ["Je suis content","Je suis très fier","Je deviens sélectionneur","Je poste 15 stories"]],
    ["Quelle ville mériterait un maillot MAR ?", ["Tanger","Nador","Casablanca","Oujda","Agadir","Fès","Marrakech","Rabat","Autre"]],
    ["Si le test te donne 72 % :", ["Je recommence","Je conteste le VAR","J’envoie à mon cousin","J’accepte difficilement"]],
    ["Pronostic Coupe du Monde 2026 ?", ["Champion du Monde","Finale","Demi-finale","Quart de finale","Je ne veux pas porter la poisse"]]
  ];

  const countries = ["France","Belgique","Pays-Bas","Espagne","Allemagne","Italie","Suisse","Canada","États-Unis","Royaume-Uni","Maroc","Autre"];
  const moroccanCities = ["Casablanca","Rabat","Tanger","Fès","Marrakech","Agadir","Oujda","Nador","Tétouan","Al Hoceima","Meknès","Kénitra","Salé","Mohammedia","El Jadida","Safi","Essaouira","Chefchaouen","Ifrane","Béni Mellal","Berkane","Dakhla","Laâyoune","Ouarzazate","Autre"];

  let current = 0;
  let answers = [];
  let score = 0;

  const overlay = document.createElement('div');
  overlay.className = 'mar212-quiz-overlay';
  overlay.innerHTML = `
    <div class="mar212-quiz-box">
      <div class="mar212-quiz-top">
        <strong>PASSEPORT MAROCAIN DU MONDE MAR212</strong>
        <button class="mar212-close">Fermer</button>
      </div>
      <div class="mar212-progress"><span></span></div>
      <div id="mar212-quiz-content"></div>
    </div>
  `;
  document.body.appendChild(overlay);

  const content = overlay.querySelector('#mar212-quiz-content');
  const progress = overlay.querySelector('.mar212-progress span');

  document.querySelectorAll('.mar212-start').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      current = 0;
      answers = [];
      score = 0;
      overlay.classList.add('active');
      renderQuestion();
    });
  });

  overlay.querySelector('.mar212-close').addEventListener('click', () => {
    overlay.classList.remove('active');
  });

  function renderQuestion() {
    const q = questions[current];
    progress.style.width = ((current) / questions.length * 100) + '%';

    content.innerHTML = `
      <div style="color:#d6af45;font-weight:900;margin-bottom:12px;">QUESTION ${current + 1} / ${questions.length}</div>
      <div class="mar212-question">${q[0]}</div>
      <div class="mar212-answers">
        ${q[1].map((a, i) => `<button class="mar212-answer" data-answer="${a}" data-points="${5 - (i % 3)}">${a}</button>`).join('')}
      </div>
    `;

    content.querySelectorAll('.mar212-answer').forEach(btn => {
      btn.addEventListener('click', function() {
        answers.push(this.dataset.answer);
        score += Number(this.dataset.points);
        current++;

        if (current < questions.length) {
          renderQuestion();
        } else {
          renderForm();
        }
      });
    });
  }

  function renderForm() {
    progress.style.width = '100%';

    content.innerHTML = `
      <div class="mar212-question">Dernière étape pour générer ton passeport</div>
      <div class="mar212-form-grid">
      <select id="mar212-gender">
  <option value="homme">Homme</option>
  <option value="femme">Femme</option>
</select>
        <input id="mar212-name" placeholder="Ton prénom" required>
        <input id="mar212-pseudo" placeholder="Ton pseudo MAR212 (visible dans le classement)" required>
        <input id="mar212-email" type="email" placeholder="Ton email" required>

        <select id="mar212-country">
          <option value="">Pays actuel</option>
          ${countries.map(c => `<option>${c}</option>`).join('')}
        </select>

        <input id="mar212-city" placeholder="Ville actuelle">

        <select id="mar212-heart-city">
          <option value="">Ville marocaine de cœur</option>
          ${moroccanCities.map(c => `<option>${c}</option>`).join('')}
        </select>

        <label class="mar212-checkbox">
          <input id="mar212-instagram" type="checkbox">
          <span>J’atteste être abonné au compte Instagram MAR pour participer aux récompenses communautaires et j’accepte de recevoir les communications liées au Passeport MAR212, au classement et aux tirages au sort.
</span>
        </label>

        <button class="mar212-btn" id="mar212-generate">Valider mon passeport</button>
        
    `;

    document.querySelector('#mar212-generate').addEventListener('click', generatePassport);
  }

  function getStatus(finalScore, gender) {
  const isFemale = gender === "femme";

  if (finalScore >= 99) return isFemale ? "Marocaine du Monde Suprême" : "Marocain du Monde Suprême";
  if (finalScore >= 97) return "Légende MAR212";
  if (finalScore >= 95) return isFemale ? "Marocaine du Monde Légendaire" : "Marocain du Monde Légendaire";
  if (finalScore >= 92) return isFemale ? "Lionne de la Diaspora" : "Lion de la Diaspora";
  if (finalScore >= 90) return isFemale ? "Ambassadrice du Bled" : "Ambassadeur du Bled";
  if (finalScore >= 88) return isFemale ? "Bledarde Premium" : "Bledard Premium";
  if (finalScore >= 85) return isFemale ? "Bledarde Officielle" : "Bledard Officiel";
  if (finalScore >= 82) return isFemale ? "Marocaine du Monde Confirmée" : "Marocain du Monde Confirmé";
  if (finalScore >= 78) return isFemale ? "Marocaine Confirmée" : "Marocain Confirmé";

  return isFemale ? "Apprentie Marocaine" : "Apprenti Marocain";
}

  function loadHtml2Canvas() {
    return new Promise((resolve, reject) => {
      if (window.html2canvas) return resolve();

      const script = document.createElement('script');
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async function waitForImages(element) {
    const images = Array.from(element.querySelectorAll('img'));

    await Promise.all(images.map(img => {
      if (img.complete) return Promise.resolve();

      return new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    }));
  }

  async function capturePassportCanvas() {
    await loadHtml2Canvas();

    const passport = document.querySelector('.mar212-quiz-overlay.active .mar212-final-passport');

    if (!passport) {
      alert("Passeport introuvable. Recharge la page et réessaie.");
      return null;
    }

    await waitForImages(passport);
    await new Promise(resolve => setTimeout(resolve, 300));

    const rawCanvas = await html2canvas(passport, {
      backgroundColor: null,
      scale: 3,
      useCORS: true,
      scrollX: 0,
      scrollY: 0
    });

    const finalCanvas = document.createElement('canvas');
    finalCanvas.width = 1080;
    finalCanvas.height = 1350;

    const ctx = finalCanvas.getContext('2d');

    const bg = ctx.createLinearGradient(0, 0, 1080, 1350);
    bg.addColorStop(0, '#0b563d');
    bg.addColorStop(0.55, '#03291f');
    bg.addColorStop(1, '#011711');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, 1080, 1350);

    const maxW = 860;
    const maxH = 1210;

    const ratio = Math.min(maxW / rawCanvas.width, maxH / rawCanvas.height);
    const drawW = rawCanvas.width * ratio;
    const drawH = rawCanvas.height * ratio;

    const x = (1080 - drawW) / 2;
    const y = (1350 - drawH) / 2;

    ctx.drawImage(rawCanvas, x, y, drawW, drawH);

    return finalCanvas;
  }

  async function downloadPassportImage(passportId) {
    const canvas = await capturePassportCanvas();
    if (!canvas) return;

    const link = document.createElement('a');
    link.download = `${passportId}-passeport-mar212-instagram.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  }

  async function sharePassportImage(passportId, shareText, shareUrl) {
    const canvas = await capturePassportCanvas();
    if (!canvas) return;

    canvas.toBlob(async function(blob) {
      const file = new File([blob], `${passportId}-passeport-mar212-instagram.png`, {
        type: "image/png"
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "Passeport MAR212",
          text: shareText + " " + shareUrl,
          files: [file]
        });
      } else {
        downloadPassportImage(passportId);
      }
    }, "image/png");
  }

  function renderPremiumPassport(pseudo, finalScore, status, country, city, heartCity, passportId) {
    return `
      <style>
        .mar212-final-passport{
          width:min(390px,100%);
          margin:24px auto;
          aspect-ratio:9/14;
          border-radius:30px;
          padding:28px;
          position:relative;
          overflow:hidden;
          color:#f8f1df;
          border:2px solid rgba(214,175,69,.85);
          background:
            radial-gradient(circle at 50% 30%, rgba(214,175,69,.18), transparent 30%),
            linear-gradient(155deg,#0b563d,#03291f 55%,#011711);
          box-shadow:0 30px 80px rgba(0,0,0,.42);
        }

        .mar212-final-passport:before{
          content:"";
          position:absolute;
          inset:16px;
          border:1px solid rgba(214,175,69,.55);
          border-radius:22px;
          pointer-events:none;
          z-index:3;
        }

        .mar212-final-passport:after{
          content:"MAR212";
          position:absolute;
          right:-38px;
          bottom:82px;
          font-size:68px;
          font-weight:900;
          color:rgba(214,175,69,.07);
          transform:rotate(-90deg);
          z-index:1;
        }

        .mar212-final-inner{
          position:relative;
          z-index:4;
          height:100%;
          display:flex;
          flex-direction:column;
          text-align:center;
        }

        .mar212-final-head{
          display:flex;
          justify-content:space-between;
          align-items:center;
          min-height:54px;
        }

        .mar212-final-flag{
          width:58px;
          height:auto;
          display:block;
          object-fit:contain;
          filter:drop-shadow(0 4px 10px rgba(0,0,0,.25));
        }

        .mar212-final-logo{
          width:92px;
          max-height:54px;
          object-fit:contain;
        }

        .mar212-final-title{
          color:#d6af45;
          font-weight:900;
          letter-spacing:.08em;
          text-transform:uppercase;
          font-size:14px;
          margin-top:18px;
          line-height:1.45;
        }

        .mar212-final-main{
          margin:auto 0;
        }

        .mar212-final-name{
          font-size:30px;
          color:#fff;
          font-weight:900;
          margin-bottom:10px;
          text-transform:uppercase;
          letter-spacing:.05em;
        }

        .mar212-final-score{
          font-size:72px;
          line-height:1;
          color:#fff;
          font-weight:900;
        }

        .mar212-final-status{
          color:#d6af45;
          font-weight:900;
          text-transform:uppercase;
          font-size:18px;
          margin-top:12px;
          line-height:1.2;
        }

        .mar212-final-meta{
          color:rgba(248,241,223,.78);
          font-size:15px;
          line-height:1.7;
          margin-top:14px;
        }

        .mar212-final-support{
          margin-top:26px;
          text-align:center;
          text-transform:uppercase;
        }

        .mar212-support-line{
          width:150px;
          height:1px;
          background:linear-gradient(90deg,transparent,rgba(214,175,69,.9),transparent);
          margin:0 auto 13px;
        }

        .mar212-support-small{
          color:#d6af45;
          font-size:15px;
          font-weight:900;
          letter-spacing:.24em;
          line-height:1;
        }

        .mar212-support-big{
          margin-top:6px;
          font-size:32px;
          line-height:1;
          font-weight:900;
          letter-spacing:.06em;
          color:#ffffff;
          text-shadow:
            0 0 8px rgba(255,255,255,.15),
            0 5px 18px rgba(0,0,0,.45);
        }

        .mar212-support-qr{
          margin-top:12px;
          display:flex;
          justify-content:center;
        }

        .mar212-support-qr img{
          width:68px;
          height:68px;
          background:#fff;
          padding:4px;
          border:2px solid rgba(214,175,69,.9);
          border-radius:10px;
          box-shadow:0 6px 16px rgba(0,0,0,.25);
        }

        .mar212-final-id{
          color:#d6af45;
          font-weight:900;
          letter-spacing:.08em;
          margin-top:auto;
          padding-top:18px;
          border-top:1px solid rgba(214,175,69,.35);
          font-size:14px;
        }
      </style>

      <div class="mar212-final-passport">
        <div class="mar212-final-inner">
          <div>
            <div class="mar212-final-head">
              <img class="mar212-final-flag" crossorigin="anonymous" src="https://cdn.shopify.com/s/files/1/0628/4722/1991/files/round_11857158_1.png?v=1780746368" alt="Maroc">
              <img class="mar212-final-logo" crossorigin="anonymous" src="https://cdn.shopify.com/s/files/1/0628/4722/1991/files/LOGO-MAROCO-CARTE-ROUGE.png?v=1780531148" alt="MAROCO">
            </div>

            <div class="mar212-final-title">
              Passeport Marocain du Monde<br>MAR212◈CDM26
            </div>
          </div>

          <div class="mar212-final-main">
            <div class="mar212-final-name">${pseudo.toUpperCase()}</div>
            <div class="mar212-final-score">${finalScore}%</div>
            <div class="mar212-final-status">${status}</div>
            <div class="mar212-final-meta">${country} • ${city}<br>Ville de cœur : ${heartCity}</div>

            <div class="mar212-final-support">
              <div class="mar212-support-line"></div>
              <div class="mar212-support-small">ALLEZ LE MAROC</div>
              <div class="mar212-support-big">DIMA MAGHRIB</div>
              <div class="mar212-support-qr">
                <img
                  crossorigin="anonymous"
                  src="https://cdn.shopify.com/s/files/1/0628/4722/1991/files/qr-code_1.png?v=1780752946"
                  alt="QR MAROCO">
              </div>
            </div>
          </div>

          <div class="mar212-final-id">${passportId}</div>
        </div>
      </div>
    `;
  }

  function generatePassport() {
    const name = document.querySelector('#mar212-name').value.trim();
    const gender = document.querySelector('#mar212-gender').value;
    const pseudo = document.querySelector('#mar212-pseudo').value.trim();
    const email = document.querySelector('#mar212-email').value.trim();
    const country = document.querySelector('#mar212-country').value || "Marocain du Monde";
    const city = document.querySelector('#mar212-city').value.trim() || "Ville secrète";
    const heartCity = document.querySelector('#mar212-heart-city').value || answers[0] || "Maroc";
    const instagram = document.querySelector('#mar212-instagram').checked;

    if (!name || !pseudo || !email || !instagram) {
      alert("Entre ton prénom, ton pseudo, ton email et confirme l’abonnement Instagram pour valider la participation.");
      return;
    }

    let finalScore = Math.round((score / (questions.length * 5)) * 100);
    finalScore = Math.max(78, Math.min(99, finalScore + Math.floor(Math.random() * 8)));

    const status = getStatus(finalScore, gender);
    const passportId = "MAR212-" + String(Math.floor(100000 + Math.random() * 899999));
    const pronostic = answers[20] || "";

    fetch(MAR212_API_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        prenom: name,
        pseudo: pseudo,
        email: email,
        pays: country,
        ville: city,
        ville_marocaine: heartCity,
        score: finalScore,
        statut: status,
        passport_id: passportId,
        pronostic: pronostic,
        instagram: instagram ? "oui" : "non",
        source: "Passeport Marocain du Monde MAR212"
      })
    });

    const shareText = `Je suis officiellement ${status} avec ${finalScore}% au Passeport Marocain du Monde MAR212 🇲🇦. Fais le test ici :`;
    const shareUrl = window.location.href;

    content.innerHTML = `
      <div class="mar212-question">Passeport validé</div>

      ${renderPremiumPassport(pseudo, finalScore, status, country, city, heartCity, passportId)}

      <div class="mar212-actions" style="justify-content:center;">
        <a class="mar212-btn" target="_blank" href="https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}">Partager WhatsApp</a>
        <a class="mar212-btn secondary" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}">Partager Facebook</a>
        <button class="mar212-btn secondary" id="mar212-copy">Copier mon résultat</button>
        <button class="mar212-btn secondary" id="mar212-download">Télécharger mon passeport</button>
        <button class="mar212-btn secondary" id="mar212-share-image">Partager l’image</button>
      </div>

      <p style="text-align:center;color:#f8f1df;margin-top:18px;">
        Des récompenses MAR seront régulièrement débloquées durant l’opération. Plus la communauté grandit, plus les surprises augmentent.
      </p>
    `;

    document.querySelector('#mar212-copy').addEventListener('click', function() {
      navigator.clipboard.writeText(shareText + ' ' + shareUrl);
      this.textContent = "Résultat copié";
    });

    document.querySelector('#mar212-download').addEventListener('click', function() {
      downloadPassportImage(passportId);
    });

    document.querySelector('#mar212-share-image').addEventListener('click', function() {
      sharePassportImage(passportId, shareText, shareUrl);
    });
  }
});
